import styled from "@emotion/styled";
import { borderRadius } from "@atlas-int/tokens";

const sizes = {
  sm: "8px",
  md: "10px",
  lg: "14px",
} as const;

type ColorDotSize = keyof typeof sizes;

const ColorDot = styled.span<{
  $color: string;
  $size?: ColorDotSize;
}>`
  display: inline-block;
  width: ${({ $size = "md" }) => sizes[$size]};
  height: ${({ $size = "md" }) => sizes[$size]};
  border-radius: ${borderRadius.full};
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export default ColorDot;
